import { MdOutlineAltRoute } from 'react-icons/md';
import { CopyToClipboard } from '@ui';
import { TripStatusChip } from '@lp/features/RoutePlanner/components/GroundTrip';
import { useDriveTripQuery } from '@/queries/drive-service';

type GroundTripTitleProps = {
  tripId: string;
};

export const GroundTripTitle = ({ tripId }: GroundTripTitleProps) => {
  const { data, isLoading } = useDriveTripQuery(tripId);

  if (!data || isLoading) return null;

  return (
    <div className="flex gap-2 items-center">
      {data.isMergedTrip && <MdOutlineAltRoute size={20} />}
      <span className="text-m-sb text-base-5">Ground Trip: {data.tripNumber}</span>
      <CopyToClipboard text={data.tripNumber} confirmationMessage="Trip number copied to clipboard" iconSize={18} />
      <TripStatusChip status={data.status} />
    </div>
  );
};
